module.exports = __webpack_public_path__ + "static/aad69e445155384edcd8f891e0a1db29d3870fc510fcc0e75714e4e177ca007b-8b6c1253c34f7062e6cb076d708bd07a.png";